import { render } from "./EPrescribingTable.vue?vue&type=template&id=fc06cad6"
import script from "./EPrescribingTable.vue?vue&type=script&lang=js"
export * from "./EPrescribingTable.vue?vue&type=script&lang=js"

import "./EPrescribingTable.vue?vue&type=style&index=0&id=fc06cad6&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__